import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="uxpcommandinfo" id="uxpcommandinfo"></a>
    <h1 {...{
      "id": "uxpcommandinfo"
    }}>{`UxpCommandInfo`}</h1>
    <a name="uxpcommandinfo-id" id="uxpcommandinfo-id"></a>
    <h2 {...{
      "id": "id--string"
    }}>{`id ⇒ `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Get command id`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{`  `}</p>
    <a name="uxpcommandinfo-label" id="uxpcommandinfo-label"></a>
    <h2 {...{
      "id": "label--string"
    }}>{`label ⇒ `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Get command label, localized string`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{`  `}</p>
    <a name="uxpcommandinfo-description" id="uxpcommandinfo-description"></a>
    <h2 {...{
      "id": "description--string"
    }}>{`description ⇒ `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Get command description, localized string`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{`  `}</p>
    <a name="uxpcommandinfo-shortcut" id="uxpcommandinfo-shortcut"></a>
    <h2 {...{
      "id": "shortcut--object"
    }}>{`shortcut ⇒ `}<inlineCode parentName="h2">{`Object`}</inlineCode></h2>
    <p>{`Get command shortcut`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Object`}</inlineCode>{` - which consists of following keys:
{string} shortcutKey
{boolean} commandKey
{boolean} altKey
{boolean} shiftKey
{boolean} ctrlKey  `}</p>
    <a name="uxpcommandinfo-ismanifestcommand" id="uxpcommandinfo-ismanifestcommand"></a>
    <h2 {...{
      "id": "ismanifestcommand--bool"
    }}>{`isManifestCommand ⇒ `}<inlineCode parentName="h2">{`bool`}</inlineCode></h2>
    <p>{`Get isManifestCommand`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`bool`}</inlineCode>{`  `}</p>
    <a name="uxpcommandinfo-commandoptions" id="uxpcommandinfo-commandoptions"></a>
    <h2 {...{
      "id": "commandoptions--object"
    }}>{`commandOptions ⇒ `}<inlineCode parentName="h2">{`object`}</inlineCode></h2>
    <p>{`Get command options parameter`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`object`}</inlineCode>{`  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      